import classNames from 'classnames/bind';
import styles from './SingleEnrollment.module.scss';
import Button from '../../../../components/Button';
import { Field, Form } from 'react-final-form';
import {
  ANNUAL_REVIEW_DATE_TITLES,
  AnnualReviewDate,
  EntityInfoFormData,
} from '../../../../state/enrollment/enrollmentModel';
import TextInput from '../../../../components/FormComponents/TextInput';
import DropdownField from '../../../../components/FormComponents/DropdownField';
import { DropdownMenuOption } from '../../../../components/DropdownMenu/DropdownMenu';
import { setEntityInfo } from '../../../../state/enrollment/enrollmentActions';
import {
  parseCCCPassphrase,
  parseCIK,
  validateEntityInfoForm,
} from './../utils/functions';

const cx = classNames.bind(styles);

const ANNUAL_REVIEW_DATE_OPTIONS: DropdownMenuOption[] = [
  {
    value: AnnualReviewDate.MARCH_31,
    label: ANNUAL_REVIEW_DATE_TITLES[AnnualReviewDate.MARCH_31],
  },
  {
    value: AnnualReviewDate.JUNE_30,
    label: ANNUAL_REVIEW_DATE_TITLES[AnnualReviewDate.JUNE_30],
  },
  {
    value: AnnualReviewDate.SEPTEMBER_30,
    label: ANNUAL_REVIEW_DATE_TITLES[AnnualReviewDate.SEPTEMBER_30],
  },
  {
    value: AnnualReviewDate.DECEMBER_31,
    label: ANNUAL_REVIEW_DATE_TITLES[AnnualReviewDate.DECEMBER_31],
  },
];

interface SingleEnrollmentProps {
  entityInfo?: EntityInfoFormData;
  isLoading: boolean;
  setEntityInfo: typeof setEntityInfo;
}

const SingleEnrollment = (props: SingleEnrollmentProps) => {
  const { entityInfo, isLoading, setEntityInfo } = props;

  const onSubmit = (formValues: EntityInfoFormData) => {
    if (formValues.cik.length < 10) {
      formValues.cik = formValues.cik.padStart(10, '0');
    }
    setEntityInfo(formValues);
  };

  return (
    <Form
      initialValues={entityInfo}
      onSubmit={onSubmit}
      validate={validateEntityInfoForm}
      render={({ handleSubmit, valid }) => (
        <form onSubmit={handleSubmit}>
          <label className={cx('single-enrollment__label')}>
            PREFERRED ANNUAL REVIEW DATE
          </label>
          <Field
            name="reviewDate"
            component={DropdownField}
            options={ANNUAL_REVIEW_DATE_OPTIONS}
          />
          <label className={cx('single-enrollment__label')}>
            ENTITY ACCESS CODES
          </label>
          <Field
            name="cik"
            component={TextInput}
            placeholder="CIK (required)"
            parse={parseCIK}
            tooltip={
              <div>
                For help finding your CIK click{' '}
                <a
                  href="https://dfinfilermanagement.zendesk.com/hc/en-us"
                  target="_blank"
                  rel="noreferrer"
                >
                  here
                </a>
                .
              </div>
            }
          />
          <Field
            name="ccc"
            component={TextInput}
            placeholder="CCC (required)"
            parse={parseCCCPassphrase}
            tooltip={
              <div>
                For help finding your CCC click{' '}
                <a
                  href="https://dfinfilermanagement.zendesk.com/hc/en-us"
                  target="_blank"
                  rel="noreferrer"
                >
                  here
                </a>
                .
              </div>
            }
          />
          <Field
            name="passphrase"
            component={TextInput}
            placeholder="Passphrase (required)"
            parse={parseCCCPassphrase}
            tooltip={
              <div>
                For help finding your Passphrase click{' '}
                <a
                  href="https://dfinfilermanagement.zendesk.com/hc/en-us"
                  target="_blank"
                  rel="noreferrer"
                >
                  here
                </a>
                .
              </div>
            }
          />
          <div className={cx('single-enrollment__footer')}>
            <Button
              onClick={() => handleSubmit()}
              disabled={!valid}
              className={cx('single-enrollment__save-btn')}
              isLoading={isLoading}
            >
              Save & Continue
            </Button>
          </div>
        </form>
      )}
    />
  );
};

export default SingleEnrollment;
